import isEqual from 'lodash/isEqual';

import { PREVIOUS_VALUE_KEY_ALIASES } from './constants';
import type { ChangedField } from './types';

function mapProposedFields(
  previous: Record<string, unknown> | null,
  proposed: Record<string, unknown>,
): Array<ChangedField> {
  return Object.keys(proposed).map((key) => {
    const previousKey = previous && key in previous ? key : PREVIOUS_VALUE_KEY_ALIASES[key];
    return { key, prev: previousKey ? previous?.[previousKey] : undefined, next: proposed[key] };
  });
}

export function getChangedFields(
  previous: Record<string, unknown> | null,
  proposed: Record<string, unknown>,
): Array<ChangedField> {
  return mapProposedFields(previous, proposed).filter(({ prev, next }) => !isEqual(prev, next));
}

export function getProposedFields(
  previous: Record<string, unknown> | null,
  proposed: Record<string, unknown>,
): Array<ChangedField> {
  return mapProposedFields(previous, proposed);
}
